import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import { getAccessSettings, SortTheList } from "../Shared/Utility";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
export default function ProgramImporterFormulaSelection() {
  const globalState = useGlobalState();

  const [programGridData, setProgramGridData] = useState([]);
  const [programPFIDealerGridData, setProgramPFIDealerGridData] = useState(
    []
  ) as any;
  const [PFIDealerGridData, setPFIDealerGridData] = useState([]) as any;
  const [ibbFormulaGridData, setIBBFormulaGridData] = useState([]) as any;

  const [showAnimation, setShowAnimation] = useState(false);

  const [programData, setProgramData] = useState({}) as any;

  const [programPFIDealerModal, setProgramPFIDealerModal] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    if (globalState.AppAccessLevelData.DID > 0) {
      window.location.href = "scorecard";
    }

    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
    } else IBBProgramID = programData.IBBProgramID;

    setProgramData((prevState: any) => ({
      ...prevState,
      IBBProgramID: IBBProgramID,
    }));

    IBBProgramGetCompleteGridDataCustom(IBBProgramID);
  }, []);

  useEffect(() => {
    checkPFIDealerAlreadyInProgram(programPFIDealerGridData);
  }, [programPFIDealerGridData]);

  useEffect(() => {
    let IBBProgramID = programData.IBBProgramID;
    let filtered = programGridData.filter(
      (item: any) => item.IBBProgramID == IBBProgramID
    ) as any;
    if (filtered.length > 0) {
      setProgramData(filtered[0]);
      IBBProgramPFIDealerGetCompleteGridDataCustom(IBBProgramID);
    }
  }, [programData.IBBProgramID]);

  function IBBProgramGetCompleteGridDataCustom(IBBProgramID: number = 0) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    object.sortexpressions = "ibbprogramid";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setProgramGridData(result[1]);

          if (IBBProgramID == 0 && result[1].length > 0) {
            setProgramData((prevState: any) => ({
              ...prevState,
              IBBProgramID: Number(result[1][0].IBBProgramID),
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramPFIDealerGetCompleteGridDataCustom(ibbprogramid: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = ibbprogramid;
    object.recordsperpage = 100;
    object.isdeleted = false;
    setPFIDealerGridData([]);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramPFIDealer/IBBProgramPFIDealerGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setProgramPFIDealerGridData(result[0]);
          //setPFIDealerGridData(result[1]);
          setIBBFormulaGridData(result[2]);
          checkPFIDealerAlreadyInProgram(result[0]);

          const deepCopy1 = JSON.parse(JSON.stringify(result[1]));
          const deepCopy2 = JSON.parse(JSON.stringify(result[1]));
          setThisGridListDataWithoutFilters(deepCopy1);
          setPFIDealerGridData(deepCopy2);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramPFIDealerSaveCustom(
    IBBProgramPFIDealerID: number,
    IBBProgramID: number,
    PFIDealerID: number,
    IBBFormulaIDForJaguar: number,
    IBBFormulaIDForLandRover: number,
    IsDeleted: boolean
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogrampfidealerid = IBBProgramPFIDealerID;
    object.ibbprogramid = IBBProgramID;
    object.pfidealerid = PFIDealerID;
    object.ibbformulaidforjaguar = IBBFormulaIDForJaguar;
    object.ibbformulaidforlandrover = IBBFormulaIDForLandRover;
    object.isdeleted = IsDeleted;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramPFIDealer/IBBProgramPFIDealerSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramPFIDealerGetCompleteGridDataCustom(IBBProgramID);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function checkPFIDealerAlreadyInProgram(programPFIDealerGridDataParam: any) {
    let PFIDealerGridDataLocal = [...PFIDealerGridData];
    for (let i = 0; i < PFIDealerGridDataLocal.length; i++) {
      let PFIDealerID = PFIDealerGridDataLocal[i].PFIDealerID;
      var filtered = programPFIDealerGridDataParam.filter(
        (item: any) => item.PFIDealerID == PFIDealerID
      );
      if (filtered.length > 0) {
        PFIDealerGridDataLocal[i].IsChecked = true;
        PFIDealerGridDataLocal[i].IsDeleted = false;
        PFIDealerGridDataLocal[i].IBBProgramPFIDealerID =
          filtered[0].IBBProgramPFIDealerID;
        PFIDealerGridDataLocal[i].IBBFormulaIDForJaguar =
          filtered[0].IBBFormulaIDForJaguar;
      } else {
        PFIDealerGridDataLocal[i].IsChecked = false;
        PFIDealerGridDataLocal[i].IsDeleted = true;
        PFIDealerGridDataLocal[i].IBBProgramPFIDealerID = 0;
        PFIDealerGridDataLocal[i].IBBFormulaIDForJaguar = 0;
      }
    }

    if (PFIDealerGridDataLocal.length > 0) {
      //setPFIDealerGridData(PFIDealerGridDataLocal);
      const deepCopy1 = JSON.parse(JSON.stringify(PFIDealerGridDataLocal));
      const deepCopy2 = JSON.parse(JSON.stringify(PFIDealerGridDataLocal));
      setThisGridListDataWithoutFilters(deepCopy1);
      setPFIDealerGridData(deepCopy2);
      setThisGridListData(deepCopy2);
      thisGridListDataRef.current = deepCopy2;
    }
  }

  function updateImporterListInProgram(
    index: number,
    type: number,
    value: any
  ) {
    let PFIDealerGridDataLocal = PFIDealerGridData as any;
    if (type == 1) {
      PFIDealerGridDataLocal[index].IsChecked = value;
      PFIDealerGridDataLocal[index].IsDeleted = !value;
    } else {
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar = value;
      PFIDealerGridDataLocal[index].IBBFormulaIDForLandRover = value;
    }
    IBBProgramPFIDealerSaveCustom(
      PFIDealerGridDataLocal[index].IBBProgramPFIDealerID,
      programData.IBBProgramID,
      PFIDealerGridDataLocal[index].PFIDealerID,
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar,
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar,
      PFIDealerGridDataLocal[index].IsDeleted
    );
    //setPFIDealerGridData(PFIDealerGridDataLocal);

    const deepCopy1 = JSON.parse(JSON.stringify(PFIDealerGridDataLocal));
    const deepCopy2 = JSON.parse(JSON.stringify(PFIDealerGridDataLocal));
    setThisGridListDataWithoutFilters(deepCopy1);
    setPFIDealerGridData(deepCopy2);
    setThisGridListData(deepCopy2);
    thisGridListDataRef.current = deepCopy2;
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setPFIDealerGridData(deepCopy);
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["", "D"]);

  useEffect(() => {
    SetSortingImage();
  }, [PFIDealerGridData]);

  function SetSortingImage() {
    if (PFIDealerGridData && PFIDealerGridData.length > 0 && document.getElementById("imgSortMarketName")) {
      (
        document.getElementById("imgSortMarketName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortDealerName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>VRM Importer Formula</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={programData.IBBProgramID}
                onChange={(e) =>
                  setProgramData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                  }))
                }
              >
                {programGridData &&
                  programGridData.map((Item: any, index: any) => (
                    <option
                      value={Item.IBBProgramID}
                      key={"year" + Item.IBBProgramID}
                    >
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>

            <span style={{ width: "33.33%" }}></span>

            <a
              className="btn-primary"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblibbformulaselection",
                  "IBBImporterFormula"
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>

          {programData.IBBProgramID > 0 && (
            <>
              <div className="p-list-grid">
                {PFIDealerGridData && (
                  <div className="section-table manage-i-table remove-scroll">
                    {programPFIDealerGridData &&
                      PFIDealerGridData &&
                      PFIDealerGridData.length > 0 &&
                      programPFIDealerGridData.length > 0 && (
                        <ColumnFilterCheckboxList
                          DataType={1}
                          RefreshFilters={refreshFilters}
                          ClearFilters={clearFilters}
                          GridData={PFIDealerGridData}
                          ColumnName={selectedColumnName}
                          ColumnFilterCheckboxListCallback={
                            filterCheckboxListCallback
                          }
                          GetFilteredLists={getFilteredLists}
                          ReturnAllFilterdLists={{}}
                          ClickPosition={clickPosition}
                          Orientation={"Center"}
                          ColumnOrientation={[
                            { Name: "MarketName", Orientation: "Right" },
                          ]}
                        />
                      )}

                    <table className="part-head trend-table fixed-table copa-in-d-table">
                      <thead>
                        <tr>
                          <th style={{ width: 100 }}>
                            <span
                              className="c-pointer"
                              onClick={(e) =>
                                ShowColumnFilterList(e, "MarketName")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              Market
                            </span>

                            <a
                              onClick={() => LoadWithSelectedSort("MarketName")}
                              title="Sort By Market"
                            >
                              <span id="imgSortMarketName"></span>
                            </a>
                          </th>
                          <th>
                            <span
                              className="c-pointer"
                              onClick={(e) =>
                                ShowColumnFilterList(e, "DealerName")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              Importer
                            </span>

                            <a
                              onClick={() => LoadWithSelectedSort("DealerName")}
                              title="Sort By Importer"
                            >
                              <span id="imgSortDealerName"></span>
                            </a>
                          </th>
                          <th style={{ width: 110 }}>Formula</th>
                        </tr>
                      </thead>
                      <tbody>
                        {thisGridListData &&
                          thisGridListData.map((item: any, index: any) => (
                            <React.Fragment key={"programPFIDealer" + index}>
                              {item.IsChecked && !item.IsExcluded && (
                                <tr>
                                  <td>{item.MarketName}</td>
                                  <td>{item.DealerName}</td>
                                  <td>
                                    {ibbFormulaGridData && (
                                      <select
                                        disabled={
                                          getAccessSettings(2, 8) > 1
                                            ? false
                                            : true
                                        }
                                        key={"FormulaSelect"}
                                        className="input-field select-field"
                                        value={item.IBBFormulaIDForJaguar}
                                        onChange={(e) => {
                                          updateImporterListInProgram(
                                            index,
                                            2,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="0">Please Select</option>
                                        {ibbFormulaGridData.map(
                                          (Item: any, index: any) => (
                                            <option
                                              value={Item.IBBFormulaID}
                                              key={
                                                "FormulaOption" +
                                                Item.IBBFormulaID
                                              }
                                            >
                                              {Item.Name}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>

                    <table
                      className="part-head trend-table fixed-table copa-in-d-table no-display"
                      id="tblibbformulaselection"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: 100 }}>Market</th>
                          <th>Importer</th>
                          <th style={{ width: 110 }}>Formula</th>
                        </tr>
                      </thead>
                      <tbody>
                        {thisGridListData &&
                          thisGridListData.map((item: any, index: any) => (
                            <React.Fragment key={"programPFIDealer" + index}>
                              {item.IsChecked && !item.IsExcluded && (
                                <tr>
                                  <td>{item.MarketName}</td>
                                  <td>{item.DealerName}</td>
                                  <td>
                                    {ibbFormulaGridData && (<>
                                     <>{item.IBBFormulaIDForJaguar == 0 && "Please Select"}</>
                                     <>{item.IBBFormulaIDForJaguar == 1 && "With DSF"}</>
                                     <>{item.IBBFormulaIDForJaguar == 2 && "Without DSF"}</>
                                     </>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
